import { create } from "zustand";

/**
 * Zustand store for the India NSE Commodity/Equity Straddle Screener.
 * Populated by the server-side India Straddle Monitor via the global LTP WebSocket.
 *
 * Each item in `straddles` matches the server broadcast shape:
 * {
 *   symbol, asset_name, underlying_symbol, underlying_ltp,
 *   atm_strike, ce_symbol, pe_symbol,
 *   ce_ltp, pe_ltp, straddle, cost_pct,
 *   dte, expiry_date, expiry_code
 * }
 */
const useIndiaStraddleStore = create((set) => ({
    straddles: [],
    lastUpdated: null,

    setSnapshot: (data) =>
        set({
            straddles: Array.isArray(data) ? data : [],
            lastUpdated: Date.now(),
        }),

    clearSnapshot: () => set({ straddles: [], lastUpdated: null }),
}));

export default useIndiaStraddleStore;
